import { render, staticRenderFns } from "./TemplateProjectSpace.vue?vue&type=template&id=b542bd60&"
import script from "./TemplateProjectSpace.vue?vue&type=script&lang=js&"
export * from "./TemplateProjectSpace.vue?vue&type=script&lang=js&"
import style0 from "./TemplateProjectSpace.vue?vue&type=style&index=0&id=b542bd60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionsProjectSectionSelector: require('/app/components/sections/project/SectionSelector.vue').default})
